/* eslint-disable react/display-name */
import * as React from 'react';
import { Img, ImgProps } from 'react-image';

const { memo } = React;
export type ImageProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;

export const Image = memo<ImageProps>(({ ...otherProps }) => {
  return <img {...(otherProps as any)} />;
});
